import { render, staticRenderFns } from "./ParisLove.vue?vue&type=template&id=4e63ad37&scoped=true&"
import script from "./ParisLove.vue?vue&type=script&lang=js&"
export * from "./ParisLove.vue?vue&type=script&lang=js&"
import style0 from "./ParisLove.vue?vue&type=style&index=0&id=4e63ad37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e63ad37",
  null
  
)

export default component.exports